<template>
  <b-modal
    id="Incidence3"
    title="ภาพเหตุการณ์และวิดีโอ"
    size="xl"
    ok-only
    ok-title="ปิด"
    @shown="resizeMap"
  >
    <div>
      <b-row class="match-height custom-modal-background2">
        <b-col cols="8">
          <b-card
            class="custom-modal-background"
          >

            <b-row>
              <b-col lg="12">
                <center>
                  <video
                    id="live"
                    :src="video"
                    style="width:auto; height:350px;"
                    muted
                    playsinline
                    autoplay
                    controls
                    loop
                  />
                </center>
              </b-col>
            </b-row>
            <Live
              ref="RTSP"
            />
          </b-card>
        </b-col>

        <b-col
          md="4"
          class="budget-wrapper"
        >
          <b-card class="custom-modal-background">
            <div class="d-sm-flex justify-content-between align-items-center mb-3">
              <h4 class="card-title mb-50 mb-sm-0">
                ข้อมูลเหตุการณ์ความปลอดภัยบนทางหลวง
              </h4>
            </div>
            <div class="d-flex align-items-center">
              <b-card-text>
                <span>วันเวลาที่<span style="color: #01A556;">เกิดเหตุการณ์</span> :</span> <span>{{ date_time }}</span>
              </b-card-text>
            </div>
            <!-- <br>
            <div
              v-if="(incident_end_time !== '' || incident_end_time !== null) && approval_status !== 2"
              class="d-flex align-items-center"
            >
              <b-card-text>
                <span>วันเวลา<span style="color: #FC6359;">สิ้นสุดเหตุการณ์</span> :</span> <span>{{ incident_end_time }}</span>
              </b-card-text>
              <br>
            </div> -->
            <!-- <div class="d-flex align-items-center">
              <b-card-text>
                <span>เหตุการณ์ความปลอดภัยบนทางหลวง :</span> <span>{{ iname }}
                  <b-link
                    v-b-modal="'modaltype'"
                    style="color:#FFA24D"
                    @click="$refs.childref.getID(selectedID)"
                  >
                    <feather-icon
                      size="13"
                      icon="EditIcon"
                    />แก้ไข
                  </b-link>
                </span>
              </b-card-text>
            </div> -->
            <!-- <div
              v-if="approval_status !== 2"
              class="d-flex align-items-center"
            >
              <b-card-text v-if="incident_end_time">
                <span>ใช้ระยะเวลา :</span> <span>{{ hours_minutes }}</span>
              </b-card-text>
              <b-card-text v-if="!incident_end_time">
                <span>ใช้ระยะเวลา :</span> <span>-</span>
              </b-card-text>
              <br>
            </div> -->
            <br>
            <div class="d-flex align-items-center">
              <b-card-text>
                <span>ชื่อกล้อง :</span> <span>{{ Camera_Desc }}</span>
              </b-card-text>
            </div>
            <br>
            <div class="d-flex align-items-center">
              <b-card-text>
                <span>จุดติดตั้งอุปกรณ์ :</span> <span>{{ sta }}</span>
              </b-card-text>
            </div>
            <br>
            <div class="d-flex align-items-center mb-1">
              <b-card-text>
                <span>เหตุการณ์ :</span> <span style="color: #ff0000; font-size: 18px;">{{ incident_type }}</span>
              </b-card-text>
            </div>
            <!-- <div
              v-if="approval_name"
              class="d-flex align-items-center mb-1"
            >
              <b-card-text>
                <span>ชื่อผู้ยืนยัน :</span> <span>{{ approval_name }}</span>
              </b-card-text>
            </div> -->

            <!-- ปุ่มแจ้งเตือน -->
            <!-- <div
              v-if="rank === 1 || (rank === 2 && userData.firstname === 'อดิศร' && userData.lastname === 'หุตะแพทย์')
                || (rank === 2 && userData.firstname === 'ธวัชชัย' && userData.lastname === 'ทองวั่น')"
              style="display: flex; justify-content: center; align-items: center; gap: 20px;"
            >
              <div>
                <b-row class="d-flex align-items-center justify-content-center mb-1">
                  <b-col
                    v-if="approval_status === 0"
                    cols="12"
                  >
                    <div
                      class="alert-body"
                      style="background-color: #FFA24D;"
                    >
                      <b-alert
                        variant="warning"
                        show
                      >
                        <span
                          style="font-size: 20px; color: #fff;"
                          class="mt-1 centered-text d-flex align-items-center justify-content-center"
                        >
                          <strong>เหตุการณ์!</strong>&nbsp;ที่รอการยืนยัน.
                        </span>
                      </b-alert>
                    </div>
                  </b-col>
                  <b-col
                    v-if="approval_status === 1"
                    cols="12"
                    class="mb-1"
                  >
                    <div
                      class="alert-body"
                      style="background-color: #01A556;"
                    >
                      <b-alert
                        variant="success"
                        show
                      >
                        <span
                          style="font-size: 20px; color: #fff;"
                          class="mt-1 centered-text d-flex align-items-center justify-content-center"
                        >
                          <strong>เหตุการณ์!</strong>&nbsp;ที่เกิดขึ้นจริง.
                        </span>
                      </b-alert>
                    </div>
                  </b-col>
                  <b-col
                    v-if="approval_status === 2"
                    cols="12"
                    class="mb-1"
                  >
                    <div
                      class="alert-body"
                      style="background-color: #FC6359;"
                    >
                      <b-alert
                        variant="danger"
                        show
                      >
                        <span
                          style="font-size: 20px; color: #fff;"
                          class="mt-1 centered-text d-flex align-items-center justify-content-center"
                        >
                          <strong>เหตุการณ์!</strong>&nbsp;ที่ไม่เกิดขึ้นจริง.
                        </span>
                      </b-alert>
                    </div>
                  </b-col>
                  <b-col
                    v-if="approval_status === 0"
                    cols="6"
                    class="d-flex align-items-center justify-content-center mt-1"
                  >
                    <b-button
                      variant="outline-success"
                      size="md"
                      @click="approveStatus(1)"
                    >
                      เหตุการณ์จริง
                    </b-button>
                  </b-col>
                  <b-col
                    v-if="approval_status === 0"
                    class="d-flex align-items-center justify-content-center mt-1"
                    cols="6"
                  >
                    <b-button
                      variant="outline-danger"
                      size="md"
                      @click="approveStatus(2)"
                    >
                      ไม่ใช่เหตุการณ์จริง
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div> -->
            <!-- -------- -->

          </b-card>
        </b-col>
        <b-col cols="8">
          <b-card
            class="custom-modal-background"
          >

            <b-row>
              <b-col lg="12">
                <center>
                  <b-img
                    :src="img"
                    height="350px"
                    @click="showImg(img)"
                  />
                </center>
              </b-col>
            </b-row>
            <Live
              ref="RTSP"
            />
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card
            class="custom-modal-background"
          >
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false, dragging:true, doubleClickZoom: false, permanent: true}"
            >
              <l-tile-layer
                :url="url"
              />
              <l-marker
                v-for="(marker, index) in markers"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.Latitude, marker.Longitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="stream(marker.RTSP_HLS)"
              >
                <l-icon
                  :icon-size="[50, 60]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/analyticSciFi/pin_cctv.png')"
                />
                <l-popup
                  ref="popup"
                >
                  <div>
                    <!-- <span style="color:#fff; padding: 10px; text-align: left; font-size: 15px;">
                ตำแหน่ง:{{ markerA.location_name }}
              </span> -->
                    <center>
                      <video
                        id="video"
                        style="width:250px; height:auto; flex-direction: row;"
                        muted
                        autoplay
                        playsinline
                        controls
                      />
                    </center>
                  </div>
                </l-popup>
              </l-marker>
            </l-map>
          </b-card>
        </b-col>
      </b-row>
      <Live
        ref="RTSP"
      />
      <EditType
        ref="childref"
        @fetch="incidentDetail2(selectedID), fetchDetail()"
      />
    </div>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import {
  BCard, BRow, BCol, BCardText, BImg, BModal,
  // BLink,
  // BButton, BTable,
  // BButton, BAlert,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import Hls from 'hls.js'
import EditType from './EditType.vue'
import Live from './LiveRTSPvideo.vue'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    // BTable,
    // BButton,
    BCard,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BRow,
    BCol,
    BCardText,
    BImg,
    BModal,
    // BAlert,
    EditType,
    // BLink,
    Live,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 15,
      center: [0, 0],
      items: [],
      markers: [],
      check: false,

      incident_type: '',
      tid: '',
      date_time: '',
      wid: '',
      latitude: '',
      longitude: '',
      camid: '',
      sta: '',
      img: '',
      video: '',
      ipaddress: '',
      Camera_Desc: '',
      // fields: [
      //   {
      //     key: 'location_id', label: 'จุดติดตั้ง:',
      //   },
      //   {
      //     key: 'location', label: 'สถานที่:',
      //   },
      //   {
      //     key: 'latitude', label: 'พิกัด:', class: 'box',
      //   },
      //   { key: 'id', label: '', class: 'text-center' },
      // ],
      rtsp: [],
      name: [],
      RTSP_HLS: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
  },
  methods: {
    incidentDetail2(wid, tid, camid) {
      axios
        .post('/getIncident-Detail', { wid, tid, camid })
        .then(response => {
          this.markers = []
          this.incident_type = response.data[0].incident_type
          this.tid = response.data[0].tid
          this.date_time = response.data[0].date_time
          this.wid = response.data[0].wid
          this.latitude = response.data[0].Latitude
          this.longitude = response.data[0].Longitude
          this.camid = response.data[0].camid
          this.sta = response.data[0].STA
          this.img = response.data[0].filepath
          this.video = response.data[0].videopath
          this.ipaddress = response.data[0].ipaddress
          this.Camera_Desc = response.data[0].Camera_Desc
          this.RTSP_HLS = response.data[0].RTSP_HLS

          this.center = []
          this.center.push(response.data[0].Latitude)
          this.center.push(response.data[0].Longitude)
          this.markers.push(response.data[0])
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchDetail() {
      this.$emit('fetch')
    },
    // eslint-disable-next-line camelcase
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 1200,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },

    stream(value) {
      console.log(value)
      setTimeout(() => {
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },

    // Resize map after modal is shown
    resizeMap() {
      this.$nextTick(() => {
        this.$refs.mymap.mapObject.invalidateSize()
      })
    },

    // approveStatus(value) {
    //   axios
    //     .post('https://khuntan-api.hwpd.go.th/approve-Status', {
    //       id: this.id, approval_status: value, prefix: this.userData.prefix, firstname: this.userData.firstname, lastname: this.userData.lastname, idcard: this.userData.idcard,
    //     })
    //     .then(() => {
    //       this.$swal({
    //         icon: 'success',
    //         title: '<span style="color:#000000">ยืนยันเหตุการณ์สำเร็จ</span>',
    //         showConfirmButton: false,
    //         timer: 1000,
    //       })
    //       this.incidentDetail2(this.selectedID)
    //       this.$emit('fetch')
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.$swal({
    //         icon: 'error',
    //         text: error.response.data.message,
    //         showConfirmButton: false,
    //         timer: 2000,
    //       })
    //     })
    // },
  },
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
.vue2leaflet-map {
    &.leaflet-container{
    // position: absolute;
    width: 100%;
    height: 350px;
    }
}
.box {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;
    color: black;
}
.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
      background: #1B1B1B;
      box-shadow: 0 3px 14px rgba(0,0,0,0.4);
      /* Green */
      border: 1px solid #1B1B1B;
      border-radius: 12px 12px 12px 12px;
  }

  .vjs-error .vjs-error-display::after{
    display: block;
    content: 'ไม่สามรถเชื่อมต่อ Streaming Server ได้ หรือ กล้องดับ';
    background: url('../../../../src//assets/images/icons/no-signal1.gif');
    height: 100%;
    width: 100%;
    font-size: 1.4em;
    text-align: center;
    line-height: 1.5;
    padding: 20px 20px;
    z-index: 1;
  }
  .vjs-modal-dialog-content{
    display: none;
  }
  .vjs-waiting .vjs-loading-spinner{
    display: none;
  }
  .vjs-modal-dialog-content {
    content: '';
  }
  .vjs-modal-dialog-content::before{
    content: 'ไม่สามรถเชื่อมต่อ Streaming Server ได้ หรือ กล้องดับ';
  }

  .custom-modal-background {
  background: linear-gradient(to bottom, #363b39, #282828) !important;
  color: #ffffff !important; /* Adjust the text color if needed */
  border-radius: 20px;
}
.custom-modal-background2 {
  background: linear-gradient(to bottom, #161d31, #000213) !important;
  color: #ffffff !important; /* Adjust the text color if needed */
}
.dark-layout .modal .modal-content, .dark-layout .modal .modal-body, .dark-layout .modal .modal-footer {
  background: linear-gradient(to bottom, #161d31, #555555) !important;
    border-color: #212336;
}

</style>
